import { createListenerMiddleware, isAnyOf, isRejected } from '@reduxjs/toolkit';
import { tr } from '../../i18n/i18n';
import {
  attendanceAction,
  curriculumActions,
  deleteAttendance,
  examActions,
  guardianActions,
  linkGuardianToStudent,
  organizationActions,
  paymentActions,
  updateOperationalTime,
} from '../action';
import { showNotification } from '../slices/notification.slice';
import { syllabusActions } from '../action/syllabus.action';
import { organizationPreferenceActions } from '../action/organizationPreference.action';
import { editTeacherData, addTeacher } from '../slices/teacherSliceModel';
import { createStudentProfile, updateStudentProfile } from '../slices/studentSliceModel';
import authActions from '../action/auth.action';
import { createPost } from '../action/post.action';
import { organizationAdminActions } from '../action/organization-admin.action';
import {
  createClassroomAssign,
  deleteClassroomAssign,
  updateClassroomAssign,
} from '../action/teacher-assign-classroom.action';
import {
  createFeeTemplate,
  updateClassroomAssignedToFeeTemplate,
  updateFeeTemplate,
} from '../action/feeTemplate.action';
import academicYearActions from '../action/academicYear.action';

export const listenerMiddleware = createListenerMiddleware();

// Listen for successful "mutating" actions (create, update, delete)
listenerMiddleware.startListening({
  matcher: isAnyOf(
    guardianActions.createGuardian.fulfilled,
    guardianActions.removeGuardian.fulfilled,
    guardianActions.changePrimaryGuardian.fulfilled,
    createStudentProfile.fulfilled,
    updateStudentProfile.fulfilled,
    linkGuardianToStudent.fulfilled,
    editTeacherData.fulfilled,
    addTeacher.fulfilled,
    curriculumActions.createCurriculum.fulfilled,
    curriculumActions.updateCurriculum.fulfilled,
    organizationPreferenceActions.putOrganizationPreferences.fulfilled,
    syllabusActions.addSyllabus.fulfilled,
    syllabusActions.updateSyllabus.fulfilled,
    paymentActions.manualPayment.fulfilled,
    examActions.createExam.fulfilled,
    examActions.updateExamAction.fulfilled,
    examActions.publishExam.fulfilled,
    examActions.releaseExam.fulfilled,
    examActions.cancelExam.fulfilled,
    attendanceAction.postAttendance.fulfilled,
    attendanceAction.postAttendanceCheckout.fulfilled,
    deleteAttendance.fulfilled,
    organizationActions.updateMyOrganization.fulfilled,
    authActions.changePasswordFirstLogin.fulfilled,
    createPost.fulfilled,
    guardianActions.updateGuardian.fulfilled,
    guardianActions.deleteGuardian.fulfilled,
    updateOperationalTime.fulfilled,
    organizationAdminActions.createOrganizationAdmin.fulfilled,
    organizationAdminActions.updateOrganizationAdmin.fulfilled,
    organizationAdminActions.deleteOrganizationAdmin.fulfilled,
    organizationActions.updateOrganization.fulfilled,
    deleteClassroomAssign.fulfilled,
    createClassroomAssign.fulfilled,
    updateClassroomAssign.fulfilled,
    updateFeeTemplate.fulfilled,
    updateClassroomAssignedToFeeTemplate.fulfilled,
    createFeeTemplate.fulfilled,
    academicYearActions.createAcademicYear.fulfilled,
    academicYearActions.updateAcademicYear.fulfilled,
  ),

  effect: (action, listenerApi) => {
    if (
      action.payload &&
      typeof action.payload === 'object' &&
      action.payload !== null &&
      'message' in action.payload
    ) {
      listenerApi.dispatch(
        showNotification({
          message: (action.payload as { message: string }).message,
          severity: 'success',
        }),
      );
    }
  },
});

listenerMiddleware.startListening({
  matcher: isRejected(),
  effect: (action, listenerApi) => {
    let errorMessage = tr('g.an_unexpected_error_occurred_2', 'An unexpected error occurred.');

    if (action.payload && typeof action.payload === 'object' && 'message' in action.payload) {
      const messageValue = (action.payload as { message: string | string[] }).message;

      // Check if the message is an array and has content
      if (Array.isArray(messageValue) && messageValue.length > 0) {
        // Join the array elements into a single string
        errorMessage = messageValue.join(', ');
      } else if (typeof messageValue === 'string') {
        // Handle the case where it's just a string
        errorMessage = messageValue;
      }
    }

    // listenerApi.dispatch(
    //   showNotification({
    //     message: errorMessage,
    //     severity: 'error',
    //   }),
    // );
  },
});
